import { render, staticRenderFns } from "./PollMultipleEditor.vue?vue&type=template&id=fa957c8c&scoped=true"
import script from "./PollMultipleEditor.vue?vue&type=script&lang=js"
export * from "./PollMultipleEditor.vue?vue&type=script&lang=js"
import style0 from "./PollMultipleEditor.vue?vue&type=style&index=0&id=fa957c8c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa957c8c",
  null
  
)

export default component.exports